import { render, staticRenderFns } from "./ResetUserPasswordSidebar.vue?vue&type=template&id=4efb1cc4&scoped=true&"
import script from "./ResetUserPasswordSidebar.vue?vue&type=script&lang=js&"
export * from "./ResetUserPasswordSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ResetUserPasswordSidebar.vue?vue&type=style&index=0&id=4efb1cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb1cc4",
  null
  
)

export default component.exports